import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/formatApiError";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Smartphone } from "lucide-react";

export const PhoneCard = () => {
  const { user, refreshSession } = useAuth();
  const [phone, setPhone] = useState(user?.phone || "");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.updateMyPhone(phone);
      refreshSession({ user: { phone: data.phone, ...(data.phone ? {} : { two_factor_channel: "email" }) } });
      setPhone(data.phone || "");
      toast.success(data.phone ? "Numéro de mobile enregistré" : "Numéro de mobile supprimé");
    } catch (err) {
      toast.error(formatApiError(err, "Numéro invalide"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="phone-card">
      <CardHeader>
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Smartphone className="h-5 w-5 text-indigo-600" /> Mon numéro de mobile
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={save} className="space-y-3">
          <div>
            <Label htmlFor="my-phone">Mobile</Label>
            <Input id="my-phone" type="tel" placeholder="06 12 34 56 78" value={phone}
              onChange={(e) => setPhone(e.target.value)} data-testid="my-phone-input" />
            <p className="text-xs text-muted-foreground mt-1">
              Utilisé pour le code de connexion par SMS et les alertes de sécurité.
            </p>
          </div>
          <Button type="submit" disabled={saving} data-testid="my-phone-save-btn">
            {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Enregistrer
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
